'use client';

import { cn } from '@repo/ui';
import { useLocale, useTranslations } from 'next-intl';
import { getLocaleMetadata, SUPPORTED_LOCALES, type SupportedLocaleType } from '@/i18n';
import { LocaleLink, useLocalePathname } from '@/lib/i18n/navigation';

export function LanguageSwitcherFooter(): React.JSX.Element {
  const t = useTranslations('footer');
  const current = useLocale() as SupportedLocaleType;
  const pathname = useLocalePathname();

  return (
    <nav aria-label={t('ariaLanguageRegion')} className="flex flex-col gap-3">
      <h3 className="text-sm font-semibold text-foreground">{t('headings.language')}</h3>
      <ul className="flex flex-wrap gap-x-6 gap-y-3">
        {SUPPORTED_LOCALES.map((locale) => {
          const meta = getLocaleMetadata(locale);
          const isCurrent = locale === current;
          return (
            <li key={locale}>
              <LocaleLink
                href={pathname}
                locale={locale}
                hrefLang={locale}
                lang={locale}
                aria-current={isCurrent ? 'true' : undefined}
                className={cn(
                  'flex items-center gap-2 text-sm text-foreground/80 hover:text-foreground transition-colors',
                  isCurrent && 'font-semibold text-foreground',
                )}
              >
                <span aria-hidden>{meta.flag}</span>
                <span dir="auto">{meta.nativeName}</span>
              </LocaleLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
